import * as Sentry from '@sentry/react';

import { Route, Routes, useLocation } from 'react-router-dom';
import { lazy, useEffect } from 'react';
import { api } from './api';

const MainApp = lazy(() => import('./MainApp'));
const AdminApp = lazy(() => import('./admin/App'));

const App = () => {
    const { pathname } = useLocation();

    useEffect(() => {
        const html = document.querySelector('html');
        const root = document.getElementById('root');
        if (!html || !root) return;
        if (pathname.startsWith('/admin')) {
            html.dir = 'ltr';
        } else {
            html.dir = 'rtl';
        }
    }, [pathname]);

    useEffect(() => {
        api.csrf();
    }, []);

    return (
        <Routes>
            <Route path='/admin/*' element={<AdminApp />} />
            <Route path='/*' element={<MainApp />} />
        </Routes>
    );
};

export default Sentry.withProfiler(App);
